import "slick-carousel/slick/slick";
import { initWowLibrary } from "@/scripts/helpers/wowAnimation";
import { initLoader, hideLoader } from "@/modules/loader/loader";
import { addedLazyLoadImages } from "@/scripts/helpers/imgLazyload";
import Accordion from "@/modules/containers/accordion";
import reviewSlider from "@/modules/section-review/index";
import howToSignBlock from "@/modules/how-to-sign/index";
import lottie from "lottie-web";
import { animationData } from "@/scripts/animation-data/animatedSignatureDark2";
import { animatedExample } from "@/scripts/animation-data/animatedExample";
import { CLASSES } from "@/scripts/helpers/constants";
import video from "@/modules/video/video";
import { detectDevice, clampTextHandler } from "@/scripts/helpers/library";
import modalShow from "@/modules/containers/modal/modal";
import contactForm from "@/modules/blocks/contact-form/index";
import {handleFullscreenHelpers} from "@/modules/accessability-exp-10743/video/video";
import { onCEDocToSendUpload, onCEDocToSignUpload } from "@/scripts/helpers/googleAnalyticsEvents";

const animateClass = ".js-ready-animate2",
  animateClassExample = ".js-ready-animate-example";

let videoWasPlayedFlag = false,
  animateWasPlayedFlag = false,
  animateWasPlayedFlag2 = false;

const dataAnimation = () => {
  let params = {
    container: document.getElementById("animatedSignatureDark"),
    renderer: "svg",
    loop: false,
    autoplay: true,
    animationData: animationData
  };

  let anim;
  anim = lottie.loadAnimation(params);
};

const dataAnimationExample = () => {
  let params = {
    container: document.getElementById("animatedSignatureExample"),
    renderer: "svg",
    loop: true,
    autoplay: true,
    animationData: animatedExample
  };

  let anim;
  anim = lottie.loadAnimation(params);
};

const showMoreGuide = () => {
  const guideLink = $(".guide-link"),
    guideContent = $(".how-to-guide-content"),
    mediaScreenDesktop = 960;

  guideLink.click(function(e) {
    e.preventDefault();
    const $link = $(e.target);
    const $content = $link.prev(guideContent);

    if ($(window).width() > mediaScreenDesktop) {
      const $contentOpen = $(".introduce-text.is-open");

      if ($contentOpen.length < 1) {
        $content.addClass(CLASSES.IS_OPEN);
      } else {
        $content.removeClass(CLASSES.IS_OPEN);

        $("html, body").animate(
          {
            scrollTop: $(".introduce-text").offset().top - 300
          },
          1000
        );
        return false;
      }
    } else {
      $content.toggleClass(CLASSES.IS_OPEN);
    }

    const htmlLink = $content.hasClass(CLASSES.IS_OPEN)
      ? "Read less"
      : "Read more";
    $link.html(htmlLink);
  });
};

const inView = function(element) {
  const win = $(window);
  const obj = element;
  const scrollPosition = win.scrollTop();
  const visibleArea = win.scrollTop() + win.height();
  const objEndPos = obj.offset().top;

  return visibleArea >= objEndPos && scrollPosition <= objEndPos;
};

const startAnimation = () => {
  const animate = document.querySelector(animateClass),
    animateExample = document.querySelector(animateClassExample);

  if (animateExample !== null) {
    window.addEventListener("scroll", event => {
      if (!animateWasPlayedFlag2 && inView($(animateExample))) {
        dataAnimationExample();
        animateWasPlayedFlag2 = true;
      }
    });
  }

  if (animate !== null) {
    window.addEventListener("scroll", event => {
      if (!animateWasPlayedFlag && inView($(animate))) {
        dataAnimation();
        animateWasPlayedFlag = true;
      }
    });
  }
};

const sendMyDocument = () => {
  $(".js-send-my-document").on("click", function(event) {
    event.preventDefault();
    $(event.target)
      .siblings()
      .focus()
      .trigger("click");
  });

  $(".js-send-my-document-button").on("click keyup", function(event) {
    if (event.keyCode === 13) {
      $("#sendMyDocument")
        .focus()
        .trigger("click");
    }
  });

  $(".js-sign-my-document-button").on("keyup", function(event) {
    if (event.keyCode === 13) {
      $("#signMyDocument")
        .focus()
        .trigger("click");
    }
  });

  $("#sendMyDocument").change(function() {
    $("#sendMyDocumentForm").submit();
    initLoader($(".loader"));
  });

  $("#signMyDocument").change(function() {
    $("#signMyDocumentForm").submit();
    initLoader($(".loader"));
  });
};

const scrollToAnchorHandler = () => {
  $(".js-scroll-to-anchor").on("click", function(e) {
    e.preventDefault();

    $("html, body").animate(
      {
        scrollTop: $($(this).attr("href")).offset().top - 88
      },
      500,
      "linear"
    );
  });
};

const selectDropdown = () => {
  const selectWrapper = $(".js-categories-select");

  $(".categories-select__option").on("click", function() {
    selectWrapper.removeClass(CLASSES.IS_OPEN);
    $("html, body").animate(
      {
        scrollTop: $($(this).attr("href")).offset().top - 100
      },
      500,
      "linear"
    );
  });

  selectWrapper.on("click", function(e) {
    if (e.target !== this) return;
    selectWrapper.toggleClass(CLASSES.IS_OPEN);
  });
};

const reviewSliderSecondary = () => {
    const parentContainer = $(".page-section--reviews")
    const slickElement = parentContainer.find(".js-review-slider-viewport"),
    nextArrow = parentContainer.find(".js-slider-arrow .btn-next-arrow"),
    prevArrow = parentContainer.find(".js-slider-arrow .btn-prev-arrow"),
    sliderSingle = parentContainer.find(".js-review-slider-viewport");

  slickElement.on("init reInit afterChange", function(
    event,
    slick,
    currentSlide,
    nextSlide
  ) {
    if (!slick.$dots) {
      return;
    }

    const counter = (currentSlide ? currentSlide : 0) + 1,
      sumCouner = slick.$dots[0].children.length;

    if (counter === 1) {
      prevArrow.addClass("is-disable");
      prevArrow.attr("tabindex", "-1");
    } else if (counter === sumCouner) {
      nextArrow.addClass("is-disable");
      nextArrow.attr("tabindex", "-1");
      prevArrow.removeClass("is-disable");
      prevArrow.removeAttr("tabindex", "-1");
    } else {
      nextArrow.removeClass("is-disable");
      nextArrow.removeAttr("tabindex", "-1");
      prevArrow.removeClass("is-disable");
      prevArrow.removeAttr("tabindex", "-1");
    }
  });

  slickElement.slick({
    infinite: false,
    slidesToShow: 1,
    speed: 600,
    arrows: false,
    accessibility: true,
    ariaPolite: true,
    adaptiveHeight: true,
    swipeToSlide: false,
    swipe: false,
    dsf: false,
    fade: true,
    dots: true,
    responsive: [
      {
        breakpoint: 959,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          centerMode: false
        }
      }
    ]
  });

  slickElement.on("afterChange", function() {
    parentContainer.find(".slick-list").removeClass("is-open");
  });

  parentContainer.find(".slick-list").attr("aria-live", "polite");

  nextArrow.click(function(e) {
    sliderSingle.slick("slickNext");
  });
  prevArrow.click(function(e) {
    sliderSingle.slick("slickPrev");
  });
};

const sliderFeatures = () => {
  const tabletBreakpoint = 959;
  const mobileBreakpoint = 639;
  const slickFeatures = $(".illustration-cards");
  const prevArrow = $(".js-slider-arrow .btn-prev-arrow");
  const nextArrow = $(".js-slider-arrow .btn-next-arrow");

  if ($(window).width() <= tabletBreakpoint && $(window).width() >= mobileBreakpoint) {
    slickFeatures.on("init reInit afterChange", function(
      event,
      slick,
      currentSlide,
      nextSlide
    ) {
      if (!slick.$dots) {
        return;
      }
      const counter = (currentSlide ? currentSlide : 0) + 1,
        sumCouner = slick.$dots[0].children.length;

      if (counter === 1) {
        prevArrow.addClass("is-disable");
        prevArrow.attr("tabindex", "-1");
        nextArrow.removeClass("is-disable");
        nextArrow.removeAttr("tabindex", "-1");
      } else if (counter === sumCouner) {
        nextArrow.addClass("is-disable");
        nextArrow.attr("tabindex", "-1");
        prevArrow.removeClass("is-disable");
        prevArrow.removeAttr("tabindex", "-1");
      } else {
        nextArrow.removeClass("is-disable");
        nextArrow.removeAttr("tabindex", "-1");
        prevArrow.removeClass("is-disable");
        prevArrow.removeAttr("tabindex", "-1");
      }
    });

    slickFeatures.slick({
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      speed: 150,
      arrows: false,
      accessibility: true,
      ariaPolite: true,
      dsf: false,
      adaptiveHeight: true,
      dots: true
    });

    nextArrow.click(function(e) {
      e.preventDefault();
      slickFeatures.slick("slickNext");
    });
    prevArrow.click(function(e) {
      e.preventDefault();
      slickFeatures.slick("slickPrev");
    });
  }
};

const introFeatures = () => {
  const mobileBreakpoint = 639;
  const slickFeatures = $(".intro-features");
  const prevArrow = $(".page-section--feature-linking .js-slider-arrow .btn-prev-arrow");
  const nextArrow = $(".page-section--feature-linking .js-slider-arrow .btn-next-arrow");

  if ($(window).width() <= mobileBreakpoint) {
    slickFeatures.on("init reInit afterChange", function(
      event,
      slick,
      currentSlide,
      nextSlide
    ) {
      if (!slick.$dots) {
        return;
      }
      const counter = (currentSlide ? currentSlide : 0) + 1,
        sumCouner = slick.$dots[0].children.length;

      if (counter === 1) {
        prevArrow.addClass("is-disable");
        prevArrow.attr("tabindex", "-1");
        nextArrow.removeClass("is-disable");
        nextArrow.removeAttr("tabindex", "-1");
      } else if (counter === sumCouner) {
        nextArrow.addClass("is-disable");
        nextArrow.attr("tabindex", "-1");
        prevArrow.removeClass("is-disable");
        prevArrow.removeAttr("tabindex", "-1");
      } else {
        nextArrow.removeClass("is-disable");
        nextArrow.removeAttr("tabindex", "-1");
        prevArrow.removeClass("is-disable");
        prevArrow.removeAttr("tabindex", "-1");
      }
    });

    slickFeatures.slick({
      infinite: false,
      slidesToShow: 1,
      speed: 150,
      arrows: false,
      accessibility: true,
      ariaPolite: true,
      dsf: false,
      adaptiveHeight: true,
      dots: true
    });

    nextArrow.click(function(e) {
      e.preventDefault();
      slickFeatures.slick("slickNext");
    });
    prevArrow.click(function(e) {
      e.preventDefault();
      slickFeatures.slick("slickPrev");
    });
  }
};

$(document).ready(function() {
  initWowLibrary();
  sendMyDocument();
  addedLazyLoadImages();
  reviewSlider();
  Accordion();
  howToSignBlock();
  startAnimation();
  showMoreGuide();
  video();
  scrollToAnchorHandler();
  selectDropdown();
  detectDevice();
  reviewSliderSecondary();
  introFeatures();
  modalShow();
  contactForm();
  clampTextHandler(45, ".pages-links-list__link");
  onCEDocToSendUpload();
  onCEDocToSignUpload();

  $(window).resize(handleFullscreenHelpers);

  $("[data-micromodal-trigger]").click(function(e) {
    e.preventDefault();
  });
});
